import { Component, OnInit } from '@angular/core';
import ScrollOut from 'scroll-out';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
})
export class CounterComponent implements OnInit {
  so: any;
  constructor() {}

  ngOnInit(): void {
    this.so = ScrollOut({
      onShown: function (el) {
        // remove the class
        el.classList.remove('animated');

        // force reflow
        void el.offsetWidth;

        // re-add the animated cl
        el.classList.add('animated');
      },
    });
  }
  ngOnDestroy() {
    this.so.teardown();
  }
}
